// The Id::ContactInfo value_type enum, in the order an owner's details read. The labels are the
// on-screen names; the values are the enum keys the write API assigns.
const CONTACT_INFO_TYPES = [
  { value: "email", label: "Email" },
  { value: "phone", label: "Phone" },
  { value: "url", label: "Website" },
  { value: "physical_address", label: "Address" },
  { value: "twitter", label: "Twitter" },
  { value: "facebook", label: "Facebook" },
  { value: "instagram", label: "Instagram" },
  { value: "linkedin", label: "LinkedIn" },
];

const contactInfoTypeLabel = (type) => CONTACT_INFO_TYPES.find((option) => option.value === type)?.label ?? type;

export { CONTACT_INFO_TYPES, contactInfoTypeLabel };
